import { en } from './en'
import { fr } from './fr'

export const formFields = {
  en,
  fr
}